// extracted by mini-css-extract-plugin
export default {"bug_report_wrapper":"Reports_bug_report_wrapper__im0iM","bug_report_form":"Reports_bug_report_form__dz4F4"};